import { render, staticRenderFns } from "./supplier-pane.vue?vue&type=template&id=2e79771a&scoped=true"
import script from "./supplier-pane.vue?vue&type=script&lang=js"
export * from "./supplier-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79771a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e79771a')) {
      api.createRecord('2e79771a', component.options)
    } else {
      api.reload('2e79771a', component.options)
    }
    module.hot.accept("./supplier-pane.vue?vue&type=template&id=2e79771a&scoped=true", function () {
      api.rerender('2e79771a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/supplier-pane.vue"
export default component.exports